import React from 'react';
import clsx from 'clsx';

const Spacing = ({ mobile, tablet, desktop, backgroundColor, position, className }) => (
  (mobile || tablet || desktop) &&
  <div className={clsx(`${mobile} ${tablet} ${desktop} ${className} ${backgroundColor} ${position} mod-spacing`)} />
);

export default Spacing;